import type { AppError } from "@/shared/api";

export type PortfolioErrorSurface =
  | "inline"
  | "field"
  | "notFound"
  | "silent"
  | "reorder"
  | "toast";

export interface MappedPortfolioError {
  surface: PortfolioErrorSurface;
  i18nKey?: string;
}

export function mapPortfolioError(err: AppError): MappedPortfolioError {
  switch (err.kind) {
    case "conflict":
      if (err.code === "portfolio_full")
        return { surface: "inline", i18nKey: "masters.portfolio.errors.full" };
      return { surface: "inline", i18nKey: "errors.server" };
    case "validation":
      if (err.code === "service_not_offered")
        return { surface: "field", i18nKey: "masters.portfolio.errors.serviceNotOffered" };
      if (err.code === "invalid_image")
        return { surface: "inline", i18nKey: "masters.portfolio.errors.invalidImage" };
      if (err.code === "invalid_photo_order")
        return { surface: "reorder", i18nKey: "masters.portfolio.errors.reorderFailed" };
      if (err.code === "invalid_id")
        return { surface: "notFound", i18nKey: "masters.portfolio.errors.masterGone" };
      return { surface: "inline", i18nKey: "errors.server" };
    case "notFound":
      if (err.code === "photo_not_found")
        return { surface: "silent" };
      return { surface: "notFound", i18nKey: "masters.portfolio.errors.masterGone" };
    case "server":
      if (err.code === "file_too_large")
        return { surface: "inline", i18nKey: "masters.portfolio.errors.tooLarge" };
      if (err.code === "unsupported_image_type")
        return { surface: "inline", i18nKey: "masters.portfolio.errors.unsupportedType" };
      return { surface: "inline", i18nKey: "errors.server" };
    case "network":
      return { surface: "inline", i18nKey: "errors.network" };
    case "forbidden":
      return { surface: "toast", i18nKey: "errors.forbidden" };
    default:
      return { surface: "toast", i18nKey: "errors.unknown" };
  }
}
